import { MutationActions, QueryKeys, useEntityMutation } from "@/api/core";
import { useApi } from "@/hooks";

interface Variables {
  id: string;
  groupId: string;
}

function useDeleteGroupStatus() {
  const api = useApi();

  return useEntityMutation({
    globalQueryKey: QueryKeys.statuses.global,
    action: MutationActions.DELETE,
    mutationFn: (variables: Variables) =>
      api.delete(
        `/api/v1/groups/${variables.groupId}/statuses/${variables.id}`,
      ),
  });
}

export { useDeleteGroupStatus };
